import React, { useEffect, useState } from 'react';
import { SessionManager, SessionState } from '@chargify/session-manager';

export type SessionGuardProps = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Session manager instance
   */
  sessionManager: SessionManager;
};

export const SessionContext = React.createContext({
  sessionInitialized: false,
});

const SessionGuard = ({ children, sessionManager }: SessionGuardProps) => {
  const [sessionInitialized, setSessionInitialize] = useState<boolean>(
    sessionManager.isManagerInitialized
  );

  useEffect(() => {
    const dispose = sessionManager.subscribe(
      ({ isInitialized }: SessionState) => {
        setSessionInitialize(isInitialized);
      }
    );

    return () => dispose();
  }, []);

  return (
    <SessionContext.Provider value={{ sessionInitialized }}>
      {children}
    </SessionContext.Provider>
  );
};

export default SessionGuard;
